module.exports = __webpack_public_path__ + "img/main-5.e386bcd3.svg";